import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import store from "../../store";
import {
  Islogin,
  setRedirectionLink,
  get_education,
  getExperience,
  get_org_type,
  get_User_District,
} from "../../actions/accountAction";
import { chunk, capitalizeFirstLetter, getQualification } from "../../helpers";
import { Link } from "react-router";
import Loader from "react-loader-spinner";
import {
  getSearchResults,
  setSearchResults,
} from "../../actions/jobseekerAction";
import { getJobTitles } from "../../actions/forgienproviderAction";

import axios from "axios";
import ServerSetting from "../../config.json";
import Autocomplete from "react-autocomplete";

const RESULT_PER_PAGE = 25;
let environment =
  typeof process.env.NODE_ENV !== "undefined" &&
    process.env.NODE_ENV === "production"
    ? "production"
    : "development";
let API_SERVER = ServerSetting[environment].API_SERVER;



class SearchNcsJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: "",
      formData1: [],
      detailText: "",
      token: null, // State to hold the token
      loading: true, // Loading state
      error: null, // Error state,
      jobData: [],
      results: [],
      activePage: 1, // Track current active page
      selectedJobTitle: "",
      jobTitlesNch: [],
      selectedJob: {},
      formData: {
        JobTitle: "",
        HighestEducation: "",
        Gender: "",
        Age: "",
        StateID: "",
        PageNumber: new URLSearchParams(this.props.location.search).get("page"),
        PageSize: "10",
      },
      pageParam: new URLSearchParams(this.props.location.search).get("page"),
    };
    this.multiselectRef = React.createRef();
    this.allJobs = React.createRef();
    if (
      localStorage.getItem("Islogin") === "true" &&
      localStorage.getItem("Islogin")
    ) {
      store.dispatch(Islogin());
    }
    store.dispatch(getSearchResults(this.props.location.query));

    store.dispatch(get_education());
    store.dispatch(getExperience());
    store.dispatch(get_org_type());
    store.dispatch(get_User_District());
    store.dispatch(getJobTitles());
  }

  componentDidMount() {
    document.title = this.props.t("sidebar.search_jobs", { param: "react" });

    var storedToken = localStorage.getItem("tokennchsearch");


    // this.fetchToken(); // Call fetchToken on component mount
    // this.fetchJobTitleData();
    this.initializeData();
    const queryData = this.props.location.query;
    const formData1 = this.state.formData1;
    formData1["education_level"] = queryData["education_level"]
      ? queryData["education_level"]
      : "";
    formData1["experience"] = queryData["experience"]
      ? queryData["experience"]
      : "";
    formData1["job_type"] = queryData["job_type"] ? queryData["job_type"] : "";
    formData1["location"] = queryData["location"]
      ? JSON.parse(queryData["location"])
      : "";
    formData1["govtType"] = queryData["govtType"] ? queryData["govtType"] : "";
    formData1["techType"] = queryData["techType"] ? queryData["techType"] : "";
    formData1["gender"] = queryData["gender"] ? queryData["gender"] : "";
    formData1["job_title"] = queryData["job_title"]
      ? queryData["job_title"]
      : "";
    formData1["pwd"] = queryData["pwd"] ? queryData["pwd"] : "";
    this.setState({ formData1 });
  }

  componentDidUpdate(prevProps) {
    const prevQuery = new URLSearchParams(prevProps.location.search).get("page");
    const newQuery = new URLSearchParams(this.props.location.search).get("page");

    if (prevQuery !== newQuery) {
      this.setState(
        (prevState) => ({
          pageParam: newQuery,
          formData: {
            ...prevState.formData,
            PageNumber: newQuery,
            JobTitle: new URLSearchParams(this.props.location.search).get("job-title"),
            HighestEducation: new URLSearchParams(this.props.location.search).get("edu"),
            Gender: new URLSearchParams(this.props.location.search).get("gen"),
            Age: new URLSearchParams(this.props.location.search).get("age"),
          },
        }),
        this.submitSearch
      );
    }
  }

  initializeData = async () => {
    await this.fetchToken(); // Fetch the token first

    try {
      await this.submitSearch(null);
      await this.fetchJobTitleData();
    } catch (error) {
      console.error("Initialization error:", error);
      this.setState({ error: "Initialization failed." });
    }
  };

  setEducationJobTitle = (value) => {
    const formData1 = this.state.formData1;
    let newValue = value;
    if (
      this.props.forgienproviderReducer.jobTitles &&
      this.props.forgienproviderReducer.jobTitles.length
    ) {
      const filterValue = this.props.forgienproviderReducer.jobTitles.filter(
        (job) => job.job_title === value
      );
      if (filterValue && filterValue.length) {
        newValue = filterValue[0].job_title;
      }
    }
    formData1["job_title"] = newValue;
    this.setState({ formData1 });
  };

  resetValues() {
    // By calling the belowe method will reset the selected values programatically
    this.multiselectRef.current.resetSelectedValues();
  }

  getExperienceToShow = (jobData) => {
    if (
      jobData.min_exp &&
      jobData.max_exp &&
      parseInt(jobData.min_exp) > 0 &&
      parseInt(jobData.max_exp) > 0
    ) {
      return `${jobData.min_exp} - ${jobData.max_exp} ${this.props.t(
        "experience.years",
        { param: "react" }
      )}`;
    } else {
      return this.props.t("JobPost.fresher", { param: "react" });
    }
  };

  parseLocation = (location) => {
    return location ? JSON.parse(location) : [];
  };

  createDistoption = () => {
    let Mainprops = this.props;
    let Distoption = [];
    if (Mainprops.actionReducer.District.length > 0) {
      Mainprops.actionReducer.District.map(function (data, index) {
        if (data.state_name === "Punjab") {
          data.dist.map(function (distdata, distindex) {
            Distoption.push({ name: distdata.name, id: distdata.id });
            return Distoption;
          });
        }
        return Distoption;
      });
    }
    return Distoption;
  };

  getStates = (job) => {
    const names = [];
    if (typeof job.state_id !== "undefined") {
      const stateArray = JSON.parse(job.state_id);
      if (
        stateArray &&
        stateArray.length &&
        this.props.actionReducer.District &&
        this.props.actionReducer.District.length > 0
      ) {
        stateArray.forEach((state) => {
          let filterVal = this.props.actionReducer.District.filter(
            (district) => district.state_id === state
          );
          if (filterVal && filterVal[0]) {
            names.push(filterVal[0].state_name);
          }
        });
      }
    }
    return names.length ? names.toString() : "";
  };

  onSelectChange = async (selectedList) => {
    const { formData1 } = this.state;
    formData1["location"] = [];
    this.setState({ formData1 });
    await this.resetValues();
    let filterDist1 = selectedList.filter((dist) => dist.id === "667");
    if (filterDist1 && filterDist1.length) {
      formData1["location"] = this.getDistrictId(filterDist1);
      this.setState({ formData1 });
      return;
    }

    let filterDist2 = selectedList.filter((dist) => dist.id === "666");
    if (filterDist2 && filterDist2.length) {
      formData1["location"] = this.getDistrictId(filterDist2);
      this.setState({ formData1 });
      return;
    }
    formData1["location"] = this.getDistrictId(selectedList);
    this.setState({ formData1 });
  };

  getDistrictId = (selectedList) => {
    let district = [];
    selectedList.length &&
      selectedList.forEach((dist) => {
        district.push(dist.id);
      });
    return district;
  };

  handleProfileInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let formData = this.state.formData1;
    formData[name] = value;
    if (name === "job_type" && value === "2") {
      delete formData["location"];
      delete formData["experience"];
      delete formData["govtType"];
      delete formData["techType"];
    }
    this.setState({ formData1: formData });
  };

  formatDate(inputDate) {
    let date = new Date(inputDate);
    let day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    let month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
    let year = date.getFullYear(); // Get the full year

    return `${day}-${month}-${year}`;
  }

  componentWillUnmount() {
    store.dispatch(setSearchResults([]));
    // localStorage.removeItem("jobDetails");
  }

  clickLink = () => {
    window.location.href = "/search-results/?gender=1";
  };

  clickLinkForBoth = () => {
    window.location.href = "/private-jobs";
  };

  clickJobLink = (id) => {
    window.location.href = "/search-results/?job_type=" + id + "&gender=1";
  };

  getLocationFromIds = (location) => {
    let newLocation = this.parseLocation(location);
    const names = [];
    if (
      this.props.actionReducer.District &&
      this.props.actionReducer.District.length > 0 &&
      newLocation &&
      newLocation.length
    ) {
      this.props.actionReducer.District.forEach((data) => {
        if (data.state_id === "3") {
          newLocation.forEach((element) => {
            let filterVal = data.dist.filter(
              (district) => district.id === element
            );
            if (filterVal && filterVal[0]) {
              names.push(filterVal[0].name);
            }
          });
        }
      });
    }
    return names.length ? names.toString() : "";
  };

  handlePageChange = (activePage) => {
    this.setState({ activePage: activePage });
  };

  clicked = (job) => {
    this.props.router.push(`/job-details/${job.id}`);
  };

  clickRegister = () => {
    if (this.state.job && this.state.job.id) {
      store.dispatch(setRedirectionLink(`job-details/${this.state.job.id}`));
      this.props.router.push("/signup?type=1");
    }
  };

  clickLogin = () => {
    if (this.state.job && this.state.job.id) {
      store.dispatch(setRedirectionLink(`job-details/${this.state.job.id}`));
      this.props.router.push("/signin");
    }
  };

  // Handle form input changes
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  // New method to fetch the token
  fetchToken = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.get(
        API_SERVER + "ncs-state-vacancy-data/get-bearer-token"
      );

      localStorage.setItem("tokennchsearch", response.data.token);
      this.setState({
        token: response.data,
        loading: false,
      });
      this.setState({ loading: false });
    } catch (error) {
      this.setState({
        error: "Failed to fetch token",
        loading: false,
      });
      console.error("Error fetching token:", error);
    }
  };

  fetchJobTitleData = async () => {
    const { token } = this.state;

    if (!this.storedToken) {
      await this.fetchToken(); // Ensure the token is fetched
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token?.token}`,
    };

    const apiUrl = API_SERVER + "ncs-state-vacancy-data/fetch-job-title-data";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
      });

      const data = await response.json();

      if (data && data.data) {
        this.setState({ jobTitlesNch: data?.data?.job_titles });
      } else {
        this.setState({ error: "No job titles found." });
      }
    } catch (error) {
      console.error("Error fetching job titles:", error);
      this.setState({ error: "Error fetching job titles from the API" });
    }
  };

  submitSearch = async (e) => {
    if (e) {
      e.preventDefault();
    }


    const { token } = this.state;
    if (!token) {
      await this.fetchToken();
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token?.token}`,
    };
    this.setState({ loading: true });

    const apiUrl = API_SERVER + "ncs-state-vacancy-data/fetch-data";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(this.state.formData),
      });

      const data = await response.json();
      let handle_results = data?.Result === "0" ? [] : data?.Result
      this.setState({
        results: data?.data || handle_results || [],
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching data:", error);

      this.setState({
        error: "Error fetching data from the API",
        loading: false,
      });
    }
  };

  submitapplycountncs = async (ncsdata) => {
    const headers = {
      "Content-Type": "application/json",
    };

    this.setState({ loading: true });

    const apiUrl = API_SERVER + "ncs-state-vacancy-data/apply";

    let payloaddata = {
      job_id: ncsdata?.JobID,
      user_id: this?.props?.actionReducer?.Loginuser?.id ? this?.props?.actionReducer?.Loginuser?.id : "",
      job_title: ncsdata?.JobTitle,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(payloaddata), // Convert the payload to JSON string
      });

      const data = await response.json();

      // Check if the response indicates success
      if (data?.success) {
        window.open(ncsdata?.VacancyURL, "_blank");
      }

      this.setState({
        // You can handle any results or further state management here
        loading: false,
      });

    } catch (error) {
      console.error("Error fetching data:", error);

      this.setState({
        error: "Error fetching data from the API",
        loading: false,
      });
    }
  };



  handleJobTitleChange = (event) => {
    this.setState({ selectedJobTitle: event.target.value });
  };

  handleClick = (job) => {
    localStorage.setItem("jobDetails", JSON.stringify(job));
  };

  // Function to handle the Next page
  nextPage = () => {
    this.props.router.push(`/outsource-jobs/?page=${parseInt(this.state.pageParam ? this.state.pageParam : 1) + 1}&age=${this.state.formData.Age}&job-title=${this.state.formData.JobTitle}&edu=${this.state.formData.HighestEducation}&gen=${this.state.formData.Gender}`)
  };

  // Function to handle the Previous page
  prevPage = () => {
    this.props.router.push(`/outsource-jobs/?page=${parseInt(this.state.pageParam ? this.state.pageParam : 1) - 1}&age=${this.state.formData.Age}&job-title=${this.state.formData.JobTitle}&edu=${this.state.formData.HighestEducation}&gen=${this.state.formData.Gender}`)
  };

  render() {
    const Mainprops = this.props;
    const { job } = this.props;
    const { activePage, formData1, formData, results, loading, error } =
      this.state;

    const isPrevDisabled = this.state.pageParam ? parseInt(this.state.pageParam) === 1 : true;
    const isNextDisabled = results.length === 0;
    // let searchResults = ''
    // if (Mainprops.JobseekerReducer.searchResults && Mainprops.JobseekerReducer.searchResults.length) {
    //     searchResults = chunk(Mainprops.JobseekerReducer.searchResults, RESULT_PER_PAGE)
    // }

    // let Mainprops.JobseekerReducer.searchResults = this.state.results
    let searchResults = "";
    if (this.state.results && this.state.results.length) {
      searchResults = chunk(this.state.results, RESULT_PER_PAGE);
    }


    const distData = this.createDistoption();

    const selectedDist = [];
    if (this.state.formData1.location && this.state.formData1.location.length) {
      this.state.formData1.location.forEach((dist) => {
        let fileter = distData.filter((fil) => fil.id === dist);
        if (fileter && fileter.length) {
          selectedDist.push(fileter[0]);
        }
      });
    }



    return (
      <div>
        <div
          className="modal fade"
          id="descriptionModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  {this.props.t("counsellingProvider.details", {
                    param: "react",
                  })}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.detailText ? this.state.detailText : ""}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primart btn-primary2"
                  data-dismiss="modal"
                  aria-label="Close Button"
                >
                  {this.props.t("counsellingProvider.close", {
                    param: "react",
                  })}
                </button>
                {/* <button type="button" className="btn btn-primary">Save changes</button> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade bd-example-modal-sm"
          tabIndex="-1"
          id="locationModal"
          role="dialog"
          aria-labelledby="mySmallModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="mySmallModalLabel">
                  {this.props.t("homeContent.locations", { param: "react" })}
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <ul className="loc-lisiting">
                  {this.state.locations && this.state.locations.length
                    ? this.state.locations.map((loc, key) => {
                      return (
                        <li key={key}>
                          <span>{loc}</span>
                        </li>
                      );
                    })
                    : ""}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="serviceModal"
          style={{ zIndex: "99999" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content d-block">
              <div className="modal-body pt-2  pb-1 text-center">
                <img
                  alt="logo"
                  src="/images/logo-new2.png"
                  className="img-fluid pb-2 home-top-logo"
                />
                <h5 className="mx-auto  text-uppercase mb-3">
                  {this.props.t("homeContent.pgrkamTitle", { param: "react" })}
                </h5>
                <div className="row d-flex">
                  <div className="col-md-6 col-lg-6 col-sm-6 mb-3 d-flex ">
                    <div className="first-click">
                      <img
                        alt="Login icon for registered users"
                        src="/images/mod2.png"
                        className="img-fluid pb-2 w-25"
                      />
                      <p className={"pl-2 pr-2"}>
                        {" "}
                        {this.props.t("homeContent.inst1", { param: "react" })}.
                      </p>
                      <Link
                        onClick={() => this.clickLogin()}
                        data-dismiss="modal"
                        style={{ color: "#fff" }}
                        className="btn btn-danger pt-1 pb-1"
                      >
                        {this.props.t("homeContent.clickToLogin", {
                          param: "react",
                        })}
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 mb-3 d-flex">
                    <div className="first-click">
                      <img
                        alt="Registration icon for new users"
                        src="/images/mod1.png"
                        className="img-fluid pb-2 w-25"
                      />
                      <p className={"pl-2 pr-2"}>
                        {this.props.t("homeContent.inst2", { param: "react" })}.
                      </p>
                      <Link
                        style={{ color: "#fff" }}
                        onClick={() => this.clickRegister()}
                        data-dismiss="modal"
                        className="btn btn-danger pt-1 pb-1"
                      >
                        {this.props.t("homeContent.clickToRegister", {
                          param: "react",
                        })}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bgclrnew p-0">
          <form onSubmit={this.submitSearch}>
            <div className="container pt-4">
              <div className="row mt-3 px-2 mainboxhead">

                <div className="col-md-12 px-0">

                  <h5 className="fWeightBold ncsHeading">
                    {/* Browse NCS Verified Job Listings Tailored to Your Career Needs */}

                    {this.props.t('banner.NCS Verified Job', { param: 'react' })}
                  </h5>

                  {/* <p className="fSize16 pb-3">Explore the Latest Job Opportunities on the NCS Job List, featuring a wide range of roles across various industries and sectors, all carefully curated and regularly updated to help you find the perfect career match.</p> */}

                </div>
                <div className="row m-0 spacegap p-0">

                  <div className="col-lg px-0">
                    <div className="form-group mb-0">
                      {/* <label htmlFor="StateID">State</label> */}
                      <select
                        onChange={this.handleInputChange}
                        className="form-select"
                        value={formData.StateID || ""}
                        name="StateID"
                        aria-label="Select state"
                      >
                        <option value={""}>
                          {this.props.t("banner.select_State", {
                            param: "react",
                          })}
                        </option>
                        {this.props?.actionReducer?.District.length > 0 &&
                          this.props?.actionReducer?.District.map(function (
                            data,
                            index
                          ) {
                            return (
                              <option key={index} value={data.state_id}>
                                {data.state_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg px-0">
                    <div className="form-group mb-0">
                      {/* <label htmlFor="highestEducation">Highest Education</label> */}
                      <select
                        onChange={this.handleInputChange}
                        className="form-select"
                        value={formData.HighestEducation || ""}
                        name="HighestEducation"
                        aria-label="Select highest education"
                      >
                        <option value={""}>
                          {this.props.t("banner.select_qualification", {
                            param: "react",
                          })}
                        </option>
                        {this.props.actionReducer.Educations.length > 0 &&
                          this.props.actionReducer.Educations.map(function (
                            data,
                            index
                          ) {
                            return (
                              <option key={index} value={data.name}>
                                {data.name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg px-0">
                    <div className="form-group mb-0">
                      {/* <label htmlFor="gender">Gender</label> */}
                      <select
                        name="Gender"
                        value={this.state.formData.Gender}
                        onChange={this.handleInputChange}
                        className="form-select"
                        aria-label="Select gender"
                      >
                        <option value="">
                          {this.props.t("banner.select_Gender", {
                            param: "react",
                          })}

                        </option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        {/* <option value="Other">Other</option> */}
                      </select>
                    </div>
                  </div>

                  {/* this.props?.actionReducer?.District */}

                  <div className="col-lg px-0">
                    <div className="form-group mb-0">
                      {/* <label htmlFor="Age">Age</label>
                  <input
                    type="number"
                    name="Age"
                    value={this.state.formData.Age}
                    onChange={this.handleInputChange}
                    className="form-control"
                    placeholder=   {this.props.t("banner.select_Age", {
                      param: "react",
                    })}
                    pattern="[0-9]"
                    maxlength="02"
                  /> */}

                      {/* <label htmlFor="Age">No. of Records</label> */}
                      <select
                        name="PageSize"
                        value={this.state.formData.PageSize}
                        onChange={this.handleInputChange}
                        className="form-select"
                        aria-label="Select number of records per page"
                      >
                        <option value="">
                          {this.props.t("Select No of Records", {
                            param: "react",
                          })}

                        </option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                        {/* <option value="Other">Other</option> */}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <p class="m-0 my-2 text-center">-----OR-----</p>
                </div>

                <div className="col-md-12 px-0 ">
                  {/* <div className="form-group mb-0">
    
                  <select
                    name="JobTitle"
                    value={formData.JobTitle}
                    onChange={this.handleInputChange}
                    className="form-select rounded-0"
                  >
                    <option value=""> {this.props.t("banner.select_job_title", {
                        param: "react",
                      })}</option>
                    {Object.entries(this.state.jobTitlesNch).map(
                      ([key, title]) => (
                        <option key={key} value={title}>
                          {title}
                        </option>
                      )
                    )}
                  </select>
                </div> */}

                  <div className={"mx-auto d-block w-100"}>
                    <div className="row m-0">
                      <div className="col-lg p-0 test">
                        <Autocomplete
                          className="w-100 form-control"
                          items={
                            []
                          }

                          renderInput={(props) => {
                            return (
                              <input
                                autoComplete="job-posts"
                                className="search-slt"
                                aria-label="Search job posts"
                                placeholder={this.props.t(
                                  "JobPost.search_placeholder",
                                  { param: "react" }
                                )}

                                {...props}
                              />
                            );
                          }}
                          wrapperStyle={{ width: "100%" }}
                          menuStyle={{
                            zIndex: "9",
                            border: "1px solid #ccc",
                            boxShadow: "1px 2px 10px #ccc",
                            padding: "4px",
                            fontSize: "14px",
                          }}
                          value={
                            formData.JobTitle
                              ? formData.JobTitle
                              : ""
                          }
                          onChange={(e) =>

                            this.setState(prevState => ({
                              formData: {
                                ...prevState.formData,
                                JobTitle: e.target.value // Replace with the desired value
                              }
                            }))
                          }

                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* 
                    <div className={"mx-auto d-block w-100"}>
                        <div className="row m-0">
                          <div className="col-lg p-0 test">
                            <Autocomplete
                              className="w-100 form-control"
                              items={
                               []
                              }
                
                              renderInput={(props) => {
                                return (
                                  <input
                                    className="search-slt"
                                    placeholder={this.props.t(
                                      "JobPost.search_placeholder",
                                      { param: "react" }
                                    )}
                                    
                                    {...props}
                                  />
                                );
                              }}
                              wrapperStyle={{ width: "100%" }}
                              menuStyle={{
                                zIndex: "9",
                                border: "1px solid #ccc",
                                boxShadow: "1px 2px 10px #ccc",
                                padding: "4px",
                                fontSize: "14px",
                              }}
                              value={
                                formData.JobTitle
                                  ? formData.JobTitle
                                  : ""
                              }
                              onChange={(e) =>
              
                                this.setState(prevState => ({
                                  formData: {
                                    ...prevState.formData,
                                    JobTitle: e.target.value // Replace with the desired value
                                  }
                                }))
                              }
               
                            />
                          </div>
                        </div>
                      </div> */}

              </div>

              <div className="col-md-2 mx-auto pb-3 mt-3">
                <button aria-label="Search Job" onClick={() => {
                  this.props.router.push(`/outsource-jobs/?page=1&age=${this.state.formData.Age}&job-title=${this.state.formData.JobTitle}&edu=${this.state.formData.HighestEducation}&gen=${this.state.formData.Gender}`)
                }} className="btn text-white wrn-btn btn-primary2">
                  {this.props.t("banner.search_job", { param: "react" })}
                </button>
              </div>
            </div>
          </form>
        </div>
        {this.state.loading ? (
          <div className="bgPositionCenter">
            <Loader
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
              type="Rings"
              color="#F1911C"
              height={100}
              width={100}
            />
          </div>
        ) : (
          <>
            <div className="tab-content border-0 pt-2 nonebg">
              <div id="home" className=" tab-pane active">
                <section className="job-details mt-4">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 mx-auto tab-content nonebg p-0">
                        <div className="panel-heading">
                          <h6 className="mb-0">
                            {this.props.t("jobSearch.results", {
                              param: "react",
                            })} (Job data sourced from National Career Service (NCS) portal for enhanced employment opportunities)
                            <span
                              className="pull-right"
                              style={{ color: "#fff" }}
                            >
                              {this?.state?.results?.length > 0
                                ? this?.state?.results?.length
                                : 0}
                              {this.props.t("JobPost.found", {
                                param: "react",
                              })}
                            </span>
                          </h6>
                        </div>
                        <div className="panel-body">
                          <div className="col-md-12 col-sm-12 col-lg-12 right-sidebar-scroll">
                            {this?.state?.results &&
                              this?.state?.results?.length > 0 ? (
                              this?.state?.results?.map((job, key) => {
                                return (
                                  <div className="right-sidebar" key={key}>
                                    <div className="first-job mb-3 px-3 pt-3">
                                      <div className="row">
                                        <div className="col-md-9">
                                          <h4 className="company-name">
                                            <Link>
                                              {this.props.t(
                                                "govtJobs.nameOfPost",
                                                {
                                                  param: "react",
                                                }
                                              )}
                                              :{" "}
                                              {capitalizeFirstLetter(
                                                job.JobTitle
                                              )}{" "}
                                              {/* ({job.JobID}) */}
                                            </Link>
                                          </h4>
                                          <h6 className="pt-1 company-name2 pb-1 mb-0 ">
                                            <Link>
                                              <img src="../images/businessman.png" alt="Name of the employer" class="pe-1" />
                                              {this.props.t(
                                                "govtJobs.nameOfEmployer",
                                                { param: "react" }
                                              )}
                                              :{" "}
                                              {capitalizeFirstLetter(
                                                job.EmployerName
                                              )}
                                            </Link>
                                          </h6>
                                          <ul className="nav">
                                            {/* {!job.hasOwnProperty('apply_link') && this.parseLocation(job.location).length ?
                                                                                <li className="w-100 pb-2 pt-0 float-left"><Link >
                                                                                    <span><span className="float-left pt-2 pb-0  font-weight-bold">{this.props.t('govtJobs.placeOfPosting', { param: 'react' })}: </span>
                                                                                        <span className="float-left pt-2 pb-0 ml-1"> {locations} {this.parseLocation(job.location).length > 3 &&
                                                                                            <span style={{ "cursor": "pointer" }} className="date-clr" data-toggle="modal"
                                                                                                data-target="#locationModal" onClick={() => this.setState({ locations: locationsArray })}>{this.props.t('homeContent.viewLocations', { param: 'react' })}</span>}
                                                                                        </span></span></Link></li>
                                                                                : null} */}
                                            {/* {!job.hasOwnProperty('apply_link') && job.state_id && !this.parseLocation(job.location).length ?
                                                                                <li className="w-100 pb-2 pt-0 float-left"><Link >
                                                                                    <span><span className="float-left pt-2 pb-0  font-weight-bold">{this.props.t('govtJobs.placeOfPosting', { param: 'react' })}: </span>
                                                                                        <span className="float-left pt-2 pb-0 ml-1"> {locations} {states.length > 3 &&
                                                                                            <span style={{ "cursor": "pointer" }} className="date-clr" data-toggle="modal"
                                                                                                data-target="#locationModal" onClick={() => this.setState({ locations: locationsArray })}>{this.props.t('homeContent.viewLocations', { param: 'react' })}</span>}
                                                                                        </span></span></Link></li>
                                                                                : null} */}
                                            {
                                              job.StateName && (
                                                <li className="w-100 p-0 float-left pt-1">
                                                  <Link>
                                                    <span>
                                                      <span className="float-left p-0 font-weight-bold">
                                                        <img src="../images/location.png" alt="Location" class="pe-1" />
                                                        {this.props.t(
                                                          "govtJobs.placeOfPosting",
                                                          { param: "react" }
                                                        )}
                                                        : &nbsp;
                                                      </span>{" "}
                                                      {capitalizeFirstLetter(
                                                        job.StateName
                                                      )}
                                                    </span>
                                                  </Link>
                                                </li>
                                              )}


                                          </ul>

                                          {job.hasOwnProperty("apply_link") && (
                                            <p className="w-100 pull-left">
                                              <span className=" float-left p-0  font-weight-bold">
                                                <img src="../images/qualification.png" alt="Qualification" class="pe-1" />
                                                {this.props.t(
                                                  "govtJobs.reqQual",
                                                  {
                                                    param: "react",
                                                  }
                                                )}
                                                :&nbsp;
                                              </span>
                                              {job.Qualification
                                                ? job.Qualification.substring(
                                                  0,
                                                  40
                                                )
                                                : ""}
                                              {job.Qualification.length > 40 ? (
                                                <Link
                                                  data-target="#descriptionModal"
                                                  data-toggle="modal"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    this.setState({
                                                      detailText:
                                                        job.Qualification,
                                                    })
                                                  }
                                                  className="date-clr"
                                                >
                                                  {this.props.t(
                                                    "homeContent.viewLocations",
                                                    { param: "react" }
                                                  )}
                                                </Link>
                                              ) : null}
                                            </p>
                                          )}
                                          {!job.hasOwnProperty(
                                            "apply_link"
                                          ) && (
                                              <p className="w-100 pull-left">
                                                <span className="float-left p-0  font-weight-bold">
                                                  <img src="../images/qualification.png" alt="Qualification" class="pe-1" />
                                                  {this.props.t(
                                                    "govtJobs.reqQual",
                                                    {
                                                      param: "react",
                                                    }
                                                  )}
                                                  :&nbsp;
                                                </span>
                                                {/* {getQualification(job)} */}
                                                {job?.Qualification === null ? "N/A" : job?.Qualification}
                                              </p>
                                            )}
                                          {!job.hasOwnProperty(
                                            "apply_link"
                                          ) && (
                                              <p className="w-100 pull-left">
                                                <span className="float-left p-0  font-weight-bold">
                                                  <img src="../images/credit.png" alt="Salary Icon" class="pe-1" />
                                                  {this.props.t(
                                                    "dashboard.table.salary",
                                                    { param: "react" }
                                                  )}
                                                  :&nbsp;
                                                </span>{" "}
                                                {/* {job.AverageWage} */}
                                                {job.MinimumWages &&
                                                  job.MaximunWages
                                                  ? job.MinimumWages +
                                                  "-" +
                                                  job.MaximunWages
                                                  : job.MinimumWages}{" "}
                                              </p>
                                            )}
                                          {/* {job.AverageWage && job.hasOwnProperty('apply_link') && <span className="pr-5"><i className="fa fa-inr pr-2"
                                                                            aria-hidden="true"></i> <span>{job.AverageWage}</span></span>} */}


                                          <div></div>
                                        </div>
                                        <div className="col-md-3 pl-0">
                                          {!job.hasOwnProperty(
                                            "apply_link"
                                          ) && (
                                              <div className="text-left">
                                                <div className=""></div>
                                                <div className="text-end">
                                                  <button
                                                    aria-label="Apply"
                                                    className="btn btn-primary btn-primary2 mt-2 ml-auto btn-center"
                                                    onClick={() => {
                                                      // window.open(
                                                      //   job?.VacancyURL,
                                                      //   "_blank"
                                                      // );
                                                      this.setState({
                                                        selectedJob: job,
                                                      })


                                                    }}

                                                    data-toggle="modal" data-target="#outsourceLinkModal"
                                                  >
                                                    {" "}
                                                    {this.props.t(
                                                      "jobSearch.apply",
                                                      {
                                                        param: "react",
                                                      }
                                                    )}{" "}
                                                  </button>
                                                </div>
                                                <div className="text-end">
                                                  <Link
                                                    className="date-clr"
                                                    // to={`/ncs-job-details`}
                                                    to={`/ncs-job-details${this?.props?.actionReducer?.Loginuser?.id ? `?user_id=${this?.props?.actionReducer?.Loginuser?.id}` : ''}`}
                                                    onClick={() =>
                                                      this.handleClick(job)
                                                    }
                                                  >
                                                    View Details
                                                  </Link>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                      <div className="row py-2 mt-2 mb-3 bgLightOrange">
                                        <div className="col-md-3 mb-1">
                                          <span className=" date-clr">
                                            <img src="/images/job-search.png" alt="job-search" class="pe-1" />
                                            {this.props.t("govtJobs.vacancy", {
                                              param: "react",
                                            })}
                                            :{" "}
                                            <span>{job.NumberofOpenings} </span>
                                          </span>
                                        </div>
                                        {job.hasOwnProperty("apply_link") && (
                                          <div className="col-md-3 mb-1">
                                            <span className=" date-clr">
                                              <img src="/images/calender.png" class="pe-1" alt="job-search" />
                                              {this.props.t(
                                                "counsellingProvider.expire_on",
                                                { param: "react" }
                                              )}
                                              :<span>{job.expiring_on} </span>
                                            </span>
                                          </div>
                                        )}
                                        {!job.hasOwnProperty("apply_link") && (
                                          <div className="col-md-3 mb-1">
                                            <span className=" date-clr">
                                              <img src="/images/calender.png" class="pe-1" alt="job-search" />

                                              {this.props.t(
                                                "homeContent.minAge",
                                                {
                                                  param: "react",
                                                }
                                              )}
                                              :{" "}
                                              <span>
                                                {/* {job.age_preference
                                                  ? job.age_preference
                                                  : ""} */}
                                                {"18"}
                                              </span>
                                            </span>
                                          </div>
                                        )}
                                        {job.hasOwnProperty("apply_link") && (
                                          <div className="col-md-3 mb-1">
                                            <span className=" date-clr">
                                              <img src="/images/exp-icon.png" class="pe-1" alt="job-search" />
                                              {this.props.t("govtJobs.age", {
                                                param: "react",
                                              })}
                                              :{" "}
                                              <span>
                                                {job.max_age ? job.max_age : ""}
                                              </span>
                                            </span>
                                          </div>
                                        )}



                                        {/* {!job.hasOwnProperty("apply_link") && (


                                          <div className="col-md-3 mb-1">
                                            <span className=" date-clr">
                                              {this.props.t("jobSearch.exp", {
                                                param: "react",
                                              })}
                                              :{" "}
                                              <span>
                                               
                                                {" " + job?.MinimumExperience}
                                              </span>
                                            </span>
                                          </div>
                                        )} */}


                                        {!job.hasOwnProperty("apply_link") && job?.MinimumExperience !== null && (
                                          <div className="col-md-3 mb-1">
                                            <span className="date-clr">
                                              <img src="/images/exp-icon.png" class="pe-1" alt="job-search" />
                                              {this.props.t("jobSearch.exp", {
                                                param: "react",
                                              })}
                                              :{" "}
                                              <span>{" " + job?.MinimumExperience}</span>
                                            </span>
                                          </div>
                                        )}


                                        {job.hasOwnProperty("apply_link") && (
                                          <div className="col-md-3 mb-1">
                                            <span className=" date-clr">
                                              <img src="/images/exp-icon.png" class="pe-1" alt="job-search" />
                                              {this.props.t("jobSearch.exp", {
                                                param: "react",
                                              })}
                                              :{" "}
                                              <span>
                                                {job.experience
                                                  ? job.experience.substring(
                                                    0,
                                                    12
                                                  )
                                                  : null}{" "}
                                                {job.experience.length > 12 ? (
                                                  <Link
                                                    data-target="#descriptionModal"
                                                    data-toggle="modal"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.setState({
                                                        detailText:
                                                          job.experience,
                                                      })
                                                    }
                                                    className="date-clr"
                                                  >
                                                    {this.props.t(
                                                      "homeContent.viewLocations",
                                                      { param: "react" }
                                                    )}
                                                  </Link>
                                                ) : null}
                                              </span>
                                            </span>
                                          </div>
                                        )}

                                        <div className="col-md-3 mb-1">
                                          {/* {job.gender_preference && ( */}
                                          <span className=" date-clr">
                                            <img src="/images/exp-icon.png" class="pe-1" alt="job-search" />
                                            Employement Type
                                            {/* {this.props.t("govtJobs.gender", {
                                              param: "react",
                                            })} */}
                                            :
                                            <span>
                                              {/* {" " + job.gender_preference} */}
                                              {" " + job?.EmploymentType}
                                              {/* {"Both"} */}{" "}
                                            </span>
                                          </span>
                                          {/* )} */}
                                        </div>

                                        {job.hasOwnProperty("apply_link") && (
                                          <>
                                            <div className="col-md-3 mb-1">
                                              <span>
                                                <span className="date-clr">
                                                  {this.props.t(
                                                    "govtJobs.applyHere",
                                                    { param: "react" }
                                                  )}
                                                  :{" "}
                                                </span>
                                                <a
                                                  rel="noopener noreferrer"
                                                  className="mr-4 mb-2"
                                                  target="_blank"
                                                  href={job.apply_link}
                                                >
                                                  {this.props.t(
                                                    "govtJobs.clickHere",
                                                    { param: "react" }
                                                  )}
                                                </a>
                                              </span>
                                            </div>
                                            <div className="col-md-3 mb-1">
                                              <span>
                                                <span className="date-clr">
                                                  {this.props.t(
                                                    "govtJobs.readNotification",
                                                    { param: "react" }
                                                  )}
                                                  :{" "}
                                                </span>
                                                <a
                                                  rel="noopener noreferrer"
                                                  className="ml-2 mb-2"
                                                  target="_blank"
                                                  href={job.pdf_link}
                                                >
                                                  {this.props.t(
                                                    "govtJobs.clickHere",
                                                    { param: "react" }
                                                  )}
                                                </a>
                                              </span>
                                            </div>
                                            <div className="col-md-3 mb-1">
                                              <span className="date-clr">
                                                {this.props.t(
                                                  "homeContent.whereToapply",
                                                  { param: "react" }
                                                )}
                                                :{" "}
                                                <span>
                                                  {capitalizeFirstLetter(
                                                    job.apply_mode
                                                  )}{" "}
                                                </span>
                                              </span>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className="row bg-color py-2 my-2 rounded10">
                                        <div className="col-md-12 d-flex align-items-center justify-content-between flex-wrap">
                                          <span style={{ color: "#fff" }}>
                                            {/* {this.props.t(
                                              !job.hasOwnProperty("apply_link")
                                                ? "homeContent.privateOrganization"
                                                : "homeContent.publicSectorVacancy",
                                              { param: "react" }
                                            )} */}
                                            {job?.SectorName} Organization: National Career Service (NCS)
                                          </span>
                                          <span className="text-right pull-right">
                                            {!job.hasOwnProperty(
                                              "apply_link"
                                            ) && (
                                                <span
                                                  style={{
                                                    color: "#fff",
                                                    marginRight: "5px",
                                                  }}
                                                  className="mr-3"
                                                >
                                                  {this.props.t(
                                                    "govtJobs.postedBy",
                                                    {
                                                      param: "react",
                                                    }
                                                  )}
                                                  :{" "}
                                                  {job.postedBy
                                                    ? job.postedBy
                                                    : "Employer"}
                                                </span>
                                              )}
                                            {job.hasOwnProperty(
                                              "apply_link"
                                            ) && (
                                                <span
                                                  style={{ color: "#fff" }}
                                                  className="mr-3"
                                                >
                                                  {this.props.t(
                                                    "govtJobs.postedBy",
                                                    {
                                                      param: "react",
                                                    }
                                                  )}
                                                  :{" "}
                                                  {job.postedBy
                                                    ? job.postedBy
                                                    : "Admin"}
                                                </span>
                                              )}
                                            <span style={{ color: "#fff" }}>
                                              {this.props.t(
                                                "homeContent.postedOn",
                                                { param: "react" }
                                              )}{" "}
                                              {/* {job.created_at} */}
                                              {/* {job.PostedDate}  */}
                                              {this.formatDate(job.PostedDate)}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-center p-3">No data found</div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 p-0 my-4 text-center">
                        <button aria-label="Previous" type="button" className="btn btn-primary2" onClick={this.prevPage} disabled={isPrevDisabled}>
                          Previous
                        </button>

                        {/* <span>Page {activePage}</span> */}

                        <button aria-label="Next" type="button" className="ms-2 btn btn-primary2" onClick={this.nextPage} disabled={isNextDisabled}>
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </section>


              </div>
            </div>
          </>
        )}

        <div className="modal fade" id="outsourceLinkModal" role="dialog" aria-labelledby="outsourceLinkModalLabel" aria-hidden="true" >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header border-bottom-0">

                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"></button>

              </div>

              <div class="modal-body py-0">
                <p className='fSize18'>You are being redirected to an external website. Please note that Punjab Rozgar Department Website cannot be held responsible for external websites.</p>
              </div>

              <div className="modal-footer border-top-0">
                <button aria-label="Proceed" type="button" className="btn btn-success" onClick={() => {

                  this.submitapplycountncs(this.state.selectedJob)
                  // window.open(this.state.outside_url, "_blank"); // Opens in a new tab

                }} data-dismiss="modal" >Proceed</button>
                <button aria-label="Cancel" type="button" className="btn btn-danger" data-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};
export default connect(mapStateToProps)(translate(SearchNcsJob));